{
  "search": "Search",
  "group": "Biome",
  "allGroups": "Every biome",
  "roster": "Characters",
  "noMatch": "Nothing matches.",
  "sections": "Character sections",
  "tabs": {
    "overview": "Overview",
    "animations": "Animations",
    "powers": "Powers",
    "talents": "Talents",
    "values": "Values",
    "sounds": "Sounds",
    "model": "Model",
    "game": "In the game"
  },
  "lore": "Lore",
  "counterplay": "Counterplay",
  "weapons": "Weapons",
  "animCategory": {
    "locomotion": "Locomotion",
    "weapon": "Weapon",
    "reaction": "Reactions",
    "death": "Death",
    "power": "Powers",
    "showcase": "Showcase"
  },
  "loop": "loops",
  "shared": "shared clip",
  "noAnims": "No animation.",
  "noPowers": "No power.",
  "noTalents": "No talent tree.",
  "tier": "tier {{tier}}",
  "cost_one": "{{count}} point",
  "cost_other": "{{count}} points",
  "value": "Value",
  "default": "Default",
  "range": "Range",
  "what": "What it does",
  "noValues": "No tunable value.",
  "slot": "Slot",
  "cue": "Cue",
  "status": "Status",
  "clips": "Clips",
  "noSounds": "No sound slot.",
  "soundStatus": {
    "ok": "OK",
    "missing": "Missing",
    "fallback": "Fallback",
    "empty": "Cue without sound files"
  },
  "mesh": {
    "rig": "Rig",
    "vertices": "Vertices",
    "triangles": "Triangles",
    "bones": "Bones",
    "renderers": "Renderers",
    "blendShapes": "Blend shapes",
    "height": "Height (m)",
    "width": "Width (m)",
    "depth": "Depth (m)"
  },
  "renders": {
    "full": "Renders",
    "bare": "Without weapons",
    "clay": "Clay"
  },
  "views": {
    "front": "Front",
    "three-quarter": "Three-quarter",
    "side": "Side",
    "back": "Back"
  },
  "lighting": "Biome lighting",
  "materials": "Materials",
  "name": "Name",
  "shader": "Shader",
  "props": "Properties",
  "textures": "Textures",
  "uv": "UV layout",
  "heroesTitle": "Heroes",
  "bestiaryTitle": "Bestiary",
  "lead": "Every {{kind}} of the pack as the Hero Sheet renders them. Read-only: the values are tuned from Tuning.",
  "kindHero": "hero",
  "kindEnemy": "monster",
  "attacks": "Attacks",
  "level": "Level",
  "build": "Build",
  "classKit": "Class kit (no talents)",
  "tree": "Tree: {{name}}",
  "botBuild": "Bot build: {{name}}",
  "levelHint": "The hero's level in the run: each level from 2 gives talent points.",
  "points": "{{spent}}/{{points}} points",
  "noTalentYet": "no talent yet",
  "barLegend": "★ new power, + changed",
  "noBuilds": "Re-render the Hero Sheet for the talent builds.",
  "bar": "Power bar",
  "fromTalent": "From the talent {{name}}",
  "changedBy": "Changed by {{names}}",
  "offBarTalent": "Not on the bar here: the talent {{name}} puts it there.",
  "offBar": "Not on the bar here: a talent replaced it.",
  "clip": "Clip",
  "noClip": "No animation",
  "inGame": "In game",
  "animationOnly": "Animation only",
  "take": "Take",
  "learnedAt": "✔ = learned at level {{level}} on {{build}}",
  "tier1": "Tier 1",
  "tier2": "Tier 2 ({{count}} points in the tree)",
  "tier3": "Capstone ({{count}} points in the tree)",
  "exclusive": "exclusive: {{group}}",
  "requires": "requires {{names}}",
  "soon": "soon",
  "fallback": "If missing",
  "silence": "silence",
  "play": "Play {{name}}",
  "noWebClips": "The clips are not published as web files.",
  "soundsOk": "Every sound of {{name}} has files.",
  "soundsMissing": "{{count}} of {{total}} sounds have no file. Add the clips to the cue asset named here (or create it on the definition) in Unity; empty cues are silent in game.",
  "onlyMissingSounds": "Only with missing sounds",
  "notPublished": "This pack's Hero Sheet is not published yet.",
  "notPublishedHow": "Regenerate it in the game (Delve/App/Docs/Hero Sheet - Update Changed), then run make prod-publish-workshop in delve-backend.",
  "newerSchema": "This content.json is schema {{schema}}; the workshop reads schema 3 and 4. Update the workshop.",
  "generated_one": "Hero Sheet of {{at}}: {{count}} character",
  "generated_other": "Hero Sheet of {{at}}: {{count}} characters",
  "published": "published {{at}}",
  "game": {
    "title": "In the game",
    "connect": "Connect to a running game in the Live tab to see this in the game.",
    "noCommand": "This game's live link has no {{cmd}} (update the live link package in delve-core).",
    "show": "▶ Show in the game",
    "stop": "■ Stop",
    "showHint": "In the connected game, this hero uses this power again and again on a target dummy (a dungeon starts with this class when none runs): the real cast with its effects, shown here live.",
    "noButton": "This power has no button to press in the game.",
    "asking": "Asking the game: {{name}} uses {{power}}…",
    "heroIdle": "▶ Show in the game: the power, live.",
    "look": "Look",
    "lookHint": "The monster in front of player 1 wearing a look: a seed's roll (empty = the set's signature look) at a gore amount. Roll in game also lists the looks of the next {{count}} seeds; pick one to wear it.",
    "seed": "Seed",
    "signature": "signature",
    "gore": "Gore {{value}} %",
    "turn": "Turn on itself",
    "preview": "Preview in game",
    "roll": "Roll in game",
    "rollHint": "The game shows this monster wearing the seed's look and lists the looks of the next {{count}} seeds.",
    "stopPreview": "■ Stop",
    "previewAsking": "Asking the game: {{name}} in front of player 1…",
    "previewing_one": "In the game: {{look}} ({{count}} part shown)",
    "previewing_other": "In the game: {{look}} ({{count}} parts shown)",
    "rolled": "Rolled in the game",
    "samples": "The Hero Sheet's sample rolls",
    "classic": "A classic monster: no modular look to roll (only modular monsters have an appearance set).",
    "horde": "Horde",
    "hordeHint": "A horde around player 1 in the connected game: crowd packs and roster monsters, like the console's horde.",
    "fodder": "Fodder",
    "regular": "Regular",
    "hordeButton": "Horde in game",
    "hordeAsking": "Asking the game for {{fodder}} fodder and {{regular}} regular monsters…",
    "hordeDone": "In the game: {{fodder}} fodder and {{regular}} regular monsters.",
    "monsterIdle": "Preview, roll or a horde: the game's view shows here."
  }
}
